'use strict';

$(function() {

  $(document).on(
    'keyup keypress blur',
    '.customerDob',
    function(e) {
      var curval = $(this).val();
      var dobPattern = /^(([0][1-9]|[1][0-2]))\/(([0][1-9])|([1][0-9])|([2][0-9])|([3][0-1]))\/([0-9]{4})$/;
      if (e.keyCode && !(e.keyCode >= 47 && e.keyCode <= 57)) { 
        e.preventDefault();  
        return false;
      }
      $(e.target).removeClass('error-msg-textbox');
      if(curval.length === 10 && curval.split('/').length === 3 && curval.match(dobPattern)){
        if(!isYearValid(curval) || isFutureDate(curval)) {
          $(e.target).addClass('error-msg-textbox');
          $(e.target).parent().find('.pattern-mismatch-text').attr('hidden', false);
        } else {
          $(e.target).parent().find('.pattern-mismatch-text').attr('hidden', true);
        }
      }
      else {
        $(e.target).addClass('error-msg-textbox');
        $(e.target).parent().find('.pattern-mismatch-text').attr('hidden', false);
      }
    }
  );
  function isYearValid(userDob){
    var dobArray = userDob.split('/');
    var dayOfBirth = dobArray[1],monthOfBirth  = dobArray[0], yearOfBirth = dobArray[2];
    const today = new Date();
    const PAST_YEAR_LIMIT = today.getFullYear() - 120;
    if(yearOfBirth < PAST_YEAR_LIMIT) {
      return false;
    }
    if(yearOfBirth%4 == 0 || yearOfBirth%400 == 0 || yearOfBirth%100 == 0) {
      if(monthOfBirth == 2 && dayOfBirth >29){
        return false;
      }
    } else {
      if(monthOfBirth == 2 && dayOfBirth >28){
        return false;
      }
    }
    return true;
  }

  function isFutureDate(userDob){
    var currentDate = new Date();
    var userDate = new Date(userDob);
    return currentDate.getTime() <= userDate.getTime();
  }
  function copyPaste(e){
    var thisDob = $(this);
    var pastedData = e.originalEvent.clipboardData.getData('text');
    if(pastedData.length > 10){
      var first10Digits = pastedData.slice(0,10);
      setTimeout(function(){
        $('.customerDob').val(first10Digits);
        $(thisDob).trigger('keyup');
      }, 10);
    }
  }
  $(document).on('paste','.customerDob', copyPaste);
});
